import { WORKOUT_EXERCISE_KEY } from '../../../model'
import updateWorkoutExerciseAction from '../update'
import WORKOUT_EXERCISES_ACTION from '../../constants/action'

export default function updateNotesWorkoutExerciseAction (value) {
  return updateWorkoutExerciseAction({
    type: WORKOUT_EXERCISES_ACTION.UPDATE_NOTE,
    payload: {
      key: WORKOUT_EXERCISE_KEY.NOTES,
      value,
      omitWorkoutUpdate: true,
      shouldNotSave: true
    }
  })
}
